import React from "react";
import "./TheyTrustUs.css";
import logo_inp from "../../assets/logos/inp-logo.png";
import logo_isims from "../../assets/logos/isims-logo.png";
import logo_gat from "../../assets/logos/logo-gat.png";
import logo_giz from "../../assets/logos/logo-giz.png";
import logo_orange from "../../assets/logos/logo-orange.png";
import logo_queen_mary from "../../assets/logos/logo-queen-mary.png";
import logo_uib from "../../assets/logos/UIB-logo.png";
import logo_unicorn_factory from "../../assets/logos/Unicorn_Factory_Lisboa-logo.png";
import logo_nvidia from "../../assets/logos/nvidia-logo.png";
import logo_amvppc from "../../assets/logos/amvppc-logo.png";
import logo_fac_sousse from "../../assets/logos/fac-sousse-logo.png";

const TheyTrustUs = ({ t }) => {
  const logos = [
    logo_inp,
    logo_isims,
    logo_gat,
    logo_giz,
    logo_orange,
    logo_queen_mary,
    logo_uib,
    logo_unicorn_factory,
    logo_nvidia,
    logo_amvppc,
    logo_fac_sousse,
  ];

  return (
    <div className="ttu-container">
      <h2 className="ttu-title">{t("they_trust_us")}</h2>
      <div className="ttu-slider">
        <div className="ttu-slider-wrapper">
          {logos.map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Logo ${index + 1}`}
              className="ttu-logo"
            />
          ))}
          {logos.map((logo, index) => (
            <img
              key={`duplicate-${index}`}
              src={logo}
              alt={`Logo ${index + 1}`}
              className="ttu-logo"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TheyTrustUs;
